import React, { useEffect, useState, useRef } from 'react'
import { Container, FieldBox } from '../../common/formParts/FieldPartsStyled'
import styled from 'styled-components'
import SVG from 'react-inlinesvg'
import helpSVG from '../../../packs/users/img/icons/Help.svg'

const EntranceForm = (props) => {
  const [entrance, setEntrance] = useState(props.entrance)
  const [isLounge, setIsLounge] = useState(props.entrance.is_lounge || false)
  const [selectionType, setSelectionType] = useState(props.entrance.selection_type || "all")
  const entrancesTypes = props.entrance_types
  const user_articles_select_options = document.getElementById("entrance_user_article_ids").selectize;
  const [showExplanation, setShowExplanation] = useState(props.entrance.selection_type === 'inverted_selection' || false)
  const [callCount, setCallCount] = useState(0)

  // hide label item with forHtml = entrance_user_article_ids-selectized
  const labelUserArticleIds = document.querySelector('label[for="entrance_user_article_ids-selectized"]')
  if (labelUserArticleIds) {
    labelUserArticleIds.style.visibility = "hidden"
  }


  const handleChangeType = (e) => {
    setEntrance({ ...entrance, selection_type: e.target.value })
    setSelectionType(e.target.value)
    if (e.target.value === "inverted_selection") {
      setShowExplanation(true)
    } else {
      setShowExplanation(false)
    }
  }

  const handleIsLounge = (e) => {
    setEntrance({ ...entrance, is_lounge: e.target.checked })
    setIsLounge(e.target.checked)
  }

  useEffect(() => {
    getUserArticleOptions(entrance.is_lounge)
  }, [entrance])

  // call server to update user_article field
  const getUserArticleOptions = (is_lounge) => {
    const articleId = document.getElementById("entrance_article_id").value
    let url = `/manage/entrances/selectable_user_articles?article_id=${articleId}`
    if (is_lounge) {
      url += `&is_lounge=${is_lounge}`
    }
    const token = document.querySelector('meta[name="csrf-token"]').content
    fetch(url, {
      method: "GET",
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": "application/json"
      },
    })
    .then((response) => {
      return response.json()
    })
    .then((data) => {
      user_articles_select_options.unlock()
      user_articles_select_options.clearOptions()
      let values = []
      for (let i in data.user_articles) {
        user_articles_select_options.addOption({value: data.user_articles[i].id, text: data.user_articles[i].name })
        values.push(data.user_articles[i].id)
      }
      user_articles_select_options.refreshOptions()
      if (selectionType === "all") {
        user_articles_select_options.setValue(values);
        // make the field unchangeable
        user_articles_select_options.lock()
        document.getElementById("entrance_user_article_ids").parentElement.parentElement.style.visibility = "hidden";
        document.getElementById("entrance_user_article_ids").parentElement.parentElement.style.height = "0";
      } else {
        if (selectionType === "inverted_selection" && callCount > 0) {
          user_articles_select_options.setValue([]);
        }
        user_articles_select_options.unlock()
        document.getElementById("entrance_user_article_ids").parentElement.parentElement.style.visibility = "visible";
        document.getElementById("entrance_user_article_ids").parentElement.parentElement.style.height = "auto";
      }
      setCallCount(callCount + 1)
    })
  }

  const handleArticleId = (articleId) => {
    setEntrance({ ...entrance, article_id: articleId })
  }

  // add event listener to article_id select box
  document.getElementById("entrance_article_id").onchange = function () {
    const articleIdValue = document.getElementById("entrance_article_id").value
    handleArticleId(articleIdValue)
  }

  return(
    <Container>
      <div className="field-unit entrances" key={"is_lounge"}>
        <div className="field-unit__label field-unit--required">
          <label htmlFor="is_lounge">阪急阪神不動産・関連施設</label>
        </div>
        <div className="field-unit__field">
          <div id={"is_lounge"}>
            <FieldBox>
              <input type="checkbox" name="entrance[is_lounge]" id="is_lounge" value="1" checked={isLounge}
                     onChange={handleIsLounge}/>
              <Help>
                <SVG src={helpSVG} className="icon" title="ヘルプ" />
                ここにチェックを入れると、下の会員住戸の選択が<br />「物件単位」から「選択された物件のアプリ単位」に変更されます。
              </Help>
            </FieldBox>
          </div>
        </div>
      </div>

      <div className="field-unit entrances" key={"entrances_type"}>
        <div className="field-unit__label field-unit--required">
          <label htmlFor="entrances_type">会員住戸の選択方法</label>
        </div>
        <div className="field-unit__field">
          <div id={"entrances_type"}>
            <FieldBox>
              { entrancesTypes.map((type) => {
                return(
                  <React.Fragment key={"key_type_"+type.value}>
                    <input
                      type="radio"
                      name="entrance[selection_type]"
                      id={"type_"+type.value}
                      value={type.value}
                      onChange={handleChangeType}
                      checked={selectionType === type.value}
                    />
                    <label htmlFor={"type_"+type.value}>{type.name}</label>
                  </React.Fragment>
                )
                })
              }
            </FieldBox>
          </div>
        </div>
      </div>

      {showExplanation &&
        <Explanation>
          <div className="field-unit entrances" key={"explanation"}>
            <div className="field-unit__label">
              <label htmlFor="explanation" className='explanation'>除外する会員住戸</label>
            </div>
            <div className="field-unit__field">
              <div id={"explanation"}>
                <p>全ての会員住戸の中から、登録したくない会員住戸を選択してください。<br />
                <span className='explanation'>ここで選択されない会員住戸は全て登録されます。</span></p>
              </div>
            </div>
          </div>
        </Explanation>
      }
    </Container>
  )
}

export default EntranceForm

export const Help = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  margin-left: 12px;
  border: 1px dashed #ccc;
  padding: 8px;
  border-radius: 8px;
  background: #f5f5f5;
  .icon {
    width: 24px;
    height: 24px;
    color: #556;
    margin-right: 4px;
  }
`

export const Explanation = styled.div`
  .explanation {
    color: red;
  }
`
